import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LocationCoordinates {
  latitude: number;
  longitude: number;
}

interface AddressState {
  address: string;
  coordinates: LocationCoordinates;
  setAddress: (address: string, coordinates?: LocationCoordinates) => void;
  clearAddress: () => void;
  getCoordinates: () => LocationCoordinates;
  getAddress: () => string
}

// Default coordinates for New Delhi, India
const DEFAULT_COORDINATES: LocationCoordinates = {
  latitude: 28.6139,
  longitude: 77.2090
};

export const useAddressStore = create<AddressState>()(
  persist(
    (set, get) => ({
      address: '',
      coordinates: {
        latitude: 30.7046,  // Coordinates for Sahibzada Ajit Singh Nagar area
        longitude: 76.7179
      },
      setAddress: (address, coordinates) => 
        set({ 
          address, 
          coordinates: coordinates || get().coordinates 
        }),
      clearAddress: () => set({ 
        address: '', 
        coordinates: DEFAULT_COORDINATES 
      }),
      getCoordinates: () => get().coordinates,
      getAddress: () => get().address
    }),
    {
      name: 'address-storage',
    }
  )
);
